// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RkCI","col":"styles_col__28Dks","actions":"styles_actions__2o-WF","conflict":"styles_conflict__QsQoT"};